export const keyParameterChangeFlagToControlName: Map<string, string> = new Map(
    [
      ['isHoursOfOperationChanged', 'hoursOfOperation'],
      ['isCostOfFuelPerUnitChanged', 'costOfFuelPerUnit'],
      ['isCostOfWaterPerUnitChanged', 'costOfWaterPerUnit'],
      ['isO2ScavengingChemicalsCostSavingsChanged', 'o2ScavengingChemicalsCostSavings'],
      ['isCostOfEffluentPerUnitChanged', 'costOfEffluentPerUnit'],
      ['isCostOfCo2PerUnitMassChanged', 'costOfCo2PerUnitMass'],
      ['isFuelTypeChanged', 'inputFuelId'],
      ['isFuelEnergyPerUnitUnitChanged', 'fuelEnergyPerUnit'],
      ['isFuelCarbonContentChanged', 'fuelCarbonContent'],
      ['isFuelConsumptionPerYearChanged', 'fuelConsumptionPerYear'],
      ['isFuelCostPerYearChanged', 'costOfFuelPerYear'],
      ['isBoilerEfficiencyChanged', 'boilerEfficiency'],
      ['isBoilerSteamGeneratedPerYearChanged', 'boilerSteamGeneratedPerYear'],
      ['isBoilerSteamGeneratedPerHourChanged', 'boilerSteamGeneratedPerHour'],
      ['isBoilerSteamPressureChanged', 'boilerSteamPressure'],
      ['isBoilerSteamTemperatureChanged', 'boilerSteamTemperature'],
      ['isBoilerAverageTdsChanged', 'boilerAverageTds'],
      ['isBoilerMaxTdsChanged', 'boilerMaxTds'],
      ['isBoilerFeedwaterConsumptionPerYearChanged', 'boilerFeedwaterConsumptionPerYear'],
      ['isPressureOfFeedtankChanged', 'pressureOfFeedtank'],
      ['isPressureOfSteamSupplyingDsiChanged', 'pressureOfSteamSupplyingDsi'],
      ['isTemperatureOfFeedtankChanged', 'temperatureOfFeedtank'],
      ['isTdsOfFeedwaterInFeedtankChanged', 'tdsOfFeedwaterInFeedtank'],
      ['isWaterTreatmentMethodChanged', 'waterTreatmentMethod'],
      ['isPercentageWaterRejectionChanged', 'percentageWaterRejection'],
      ['isTemperatureOfMakeupWaterChanged', 'temperatureOfMakeupWater'],
      ['isMakeupWaterAmountPerYearChanged', 'makeupWaterAmountPerYear'],
      ['isPercentageOfCondensateReturnChanged', 'percentageOfCondensateReturn'],
      ['isVolumeOfCondensateReturnChanged', 'volumeOfCondensateReturn'],
      ['isTemperatureOfCondensateReturnChanged', 'temperatureOfCondensateReturn'],
      ['isTdsOfCondensateReturnChanged', 'tdsOfCondensateReturn'],
      ['isBoilerHouseEffluentChanged', 'percentOfEffluentBoilerHouseWater']
    ]);

